import React from "react"
import { useTranslation } from "react-i18next"

import { Stack, Typography } from "@mui/material"
import { GridOverlay } from "@mui/x-data-grid-pro"

export const SiteBillsErrorOverlay: React.FC = () => {
  const { t } = useTranslation("sites")

  return (
    <GridOverlay>
      <Stack
        sx={{
          alignItems: "center",
          gap: 1,
          textAlign: "center",
        }}
      >
        <Typography variant="h3">{t("bills.grid.loadError.title")}</Typography>
        <Typography variant="body2">
          {t("bills.grid.loadError.description")}
        </Typography>
      </Stack>
    </GridOverlay>
  )
}
